import { render } from "./UploadInvestorDoc.vue?vue&type=template&id=326ba8bd&scoped=true&ts=true"
import script from "./UploadInvestorDoc.vue?vue&type=script&lang=ts"
export * from "./UploadInvestorDoc.vue?vue&type=script&lang=ts"

import "./UploadInvestorDoc.vue?vue&type=style&index=0&id=326ba8bd&scoped=true&lang=css"
import "./UploadInvestorDoc.vue?vue&type=style&index=1&id=326ba8bd&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326ba8bd"]])

export default __exports__